import { Grid } from '../../../../../Common/Grid'
import { Button, Typography } from '@fullscreendigital/carrefour-dex-fe'
import React, { useMemo, useState } from 'react'
import { getValidationSchema, initialValues } from './helpers'
import { useFormik } from 'formik'
import { formatErrorMessage } from '../../../../../../../utils/formatting'
import { useNotification } from '../../../../../../../hooks'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import {
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CircularProgress, Paper
} from "@mui/material";
import { URLS } from '../../../../constants'
import { TitleHeader } from '../../../../Common/TitleHeader'
import { makeCoreGetRequest, makeCorePostRequest } from '../../../../../../../utils/api'
import { DeleteActionIcon } from '../../../../../../../icons'

const RecordReturnDetail = () => {
  const { showNotification } = useNotification()
  const navigate = useNavigate()
  const [selectedNls, setSelectedNls] = useState([])
  const [open, setOpen] = useState(false);

  const [params] = useSearchParams()
  const truckId = params.get('id')

  const validationSchema = useMemo(() => getValidationSchema(), [])
  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async () => {
      try {
        const payload = formik.values.blList.map(bl => bl.id)
        await makeCorePostRequest('/shop-reception-mobile/truck/hub/return/registration/save-notices/' + truckId, payload)
        navigate(`${URLS.AUTH_RECORD_RETURN_STEP_3}?id=${truckId}`)
      } catch (error) {
        showNotification({
          message: `Error while submitting. ${formatErrorMessage(error)}`,
          type: 'error'
        })
      }
    }
  })

  const { data: truck, isLoading: isLoadingTruck } = useQuery(
    'truckModel',
    async () => {
      return await makeCoreGetRequest(`/shop-reception-mobile/truck/hub/return/registration/truck/${truckId}`)
    },
    {
      onError: error => {
        showNotification({
          message: `Error while fetching truck. ${formatErrorMessage(error)}`,
          type: 'error'
        })
      }
    }
  )

  const { data: noticeList, isLoading: isNoticeListLoading } = useQuery(
    'getNoticeListId',
    async () => {
      const list = await makeCoreGetRequest(
        '/shop-reception-mobile/truck/hub/return/registration/notices/' + truckId,
        null
      )
      await formik.setFieldValue('blList', list)
      return list
    },
    {
      initialData: [],
      onError: error => {
        showNotification({
          message: `Error while fetching truck. ${formatErrorMessage(error)}`,
          type: 'error'
        })
      }
    }
  )

  const { data: noticeLists, isLoading: isNoticeListsLoading } = useQuery(
    'getNoticeLists',
    async () => {
      return await makeCoreGetRequest(
        '/shop-reception-mobile/truck/hub/return/registration/all-notices',
        null
      )
    },
    {
      onError: error => {
        showNotification({
          message: `Error while fetching truck. ${formatErrorMessage(error)}`,
          type: 'error'
        })
      }
    }
  )

  const handleSelectChange = event => {
    const value = event.target.value
    formik.setFieldValue('blList', value)
    setSelectedNls(value)
    setOpen(false);
  }

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const removeBl = idx => {
    const newList = formik.values.blList.filter((_, index) => index !== idx)
    formik.setFieldValue('blList', newList)
    setSelectedNls(newList)
  }

  const totalStackNumber = formik.values.blList.reduce((total, nl) => total + nl.stackNumber, 0);

  let items = [
    <TitleHeader title="ÎNREGISTRARE RETUR" />,
    <Paper elevation={3} style={{ padding: '20px' }}>
      <Typography variant="medium" component="p">
        Numǎr camion: {truck?.truckNumber}
      </Typography>
      <Typography variant="medium" component="p">
        Destinație: {truck?.depositName}
      </Typography>
    </Paper>,
    <Select
      sx={{ width: '100%' }}
      multiple
      value={formik.values?.blList}
      onChange={handleSelectChange}
      open={open}
      onOpen={handleOpen}
      onClose={handleClose}
      displayEmpty
      renderValue={() => 'Adauga aviz'}
    >
      {noticeLists?.map(nl => (
        <MenuItem key={nl.id} value={nl}>
          {nl.noticeNumber} - {nl.shopName}
        </MenuItem>
      ))}
    </Select>,
    <Table>
      <TableHead style={{ backgroundColor: '#0970E6' }}>
        <TableRow>
          <TableCell>Numar aviz</TableCell>
          <TableCell>Magazin</TableCell>
          <TableCell>Numar stive</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {formik.values.blList?.map((nl, index) => (
          <TableRow key={index}>
            <TableCell>{nl.noticeNumber}</TableCell>
            <TableCell>{nl.shopName}</TableCell>
            <TableCell>{nl.stackNumber}</TableCell>
            <TableCell>
              <Button onClick={() => removeBl(index)} label="">
                <DeleteActionIcon />
              </Button>
            </TableCell>
          </TableRow>
        ))}
        <TableRow>
          <TableCell><strong>Total</strong></TableCell>
          <TableCell></TableCell>
          <TableCell>{totalStackNumber}</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableBody>
    </Table>,
    <Button
      style={{ width: '100%' }}
      type="button"
      variant="contained"
      label="CONFIRMǍ"
      disabled={formik.values.blList?.length === 0 || formik.isSubmitting}
      onClick={() => formik.handleSubmit()}
    />,
    <Button
      style={{ width: '100%' }}
      type="button"
      variant="contained"
      label="Modifica Date Camion"
      onClick={() => navigate(URLS.AUTH_RECORD_RETURN, {state: { truckId: truckId }})}
    />
  ]

  if (isNoticeListLoading || isNoticeListsLoading) {
    return <CircularProgress color="primary" style={{ margin: '40px auto' }} disableShrink />
  }

  return (
    <Grid gridContainerStyle={{ marginTop: '20px' }} maxWidth="xs" items={items} itemsPerRow={1} />
  )
}

export default RecordReturnDetail
